import { Box } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Drawer from '../../../../components/Drawer/Drawer';
import { reset } from '../../../../stores/AssignDeviceStore';
import AssignUserSelectUserStep from './AssignUserSelectUserStep';
import AssignUserSummaryStep from './AssignUserSummaryStep';
import useAssignUser from './useAssignUser';

interface AssignUserDrawerProps {
  open: boolean;
  onClose: () => void;
  onAssignSuccess: () => void;
}
function AssignUserDrawer({ open, onClose, onAssignSuccess }: AssignUserDrawerProps) {
  const dispatch = useDispatch();
  useAssignUser();

  /**
   * Handle the close action
   */
  const handleClose = () => {
    dispatch(reset());
    onClose();
  };
  const [t] = useTranslation();
  const [progress, setProgress] = useState(50);
  const [step, setStep] = useState(1);
  const NUMBER_OF_STEPS = 2;

  React.useEffect(() => {
    setProgress((step / NUMBER_OF_STEPS) * 100);
  }, [step]);

  /**
   * Handle the back button of the drawer to close or to go back a step
   */
  const handleBackButton = () => {
    if (step === 1) {
      handleClose();
    } else {
      setStep((prevState) => prevState - 1);
    }
  };

  /**
   * Render each step of the device assignment journey
   */
  const renderSteps = () => {
    switch (step) {
      case 1:
        return <AssignUserSelectUserStep onClose={handleClose} nextStep={() => setStep(2)} />;
      case 2:
        return <AssignUserSummaryStep onClose={handleClose} onAssignSuccess={onAssignSuccess} />;
      default:
        return null;
    }
  };

  return (
    <Drawer
      disablePortal
      open={open}
      onClose={handleClose}
      onBackButton={handleBackButton}
      anchor="right"
      title={t('pages.devicesReport.assignUserDrawer.title')}
      progress={progress}
    >
      <Box sx={{ paddingTop: '1rem', height: '100%' }}>{renderSteps()}</Box>
    </Drawer>
  );
}

export default AssignUserDrawer;
